import { styled } from "@mui/material/styles";
import { Icons as GridIcons } from "Components/AppGrid/shipeezi-new-grid";
import { CgImport } from "react-icons/cg";

import { Button } from "../../../../../../../components/Form";

export const ImportIcon = styled(CgImport)(() => ({
  marginRight: "10px",
  fontSize: "14px",
}));

export const ChangeStatusIcon = styled(GridIcons.status)(() => ({
  cursor: "pointer",
}));

export const DeleteIcon = styled(GridIcons.delete)(() => ({
  cursor: "pointer",
}));

export const ViewIcon = styled(GridIcons.view)(() => ({
  cursor: "pointer",
}));

interface BadgeStatusProps {
  isActive: boolean;
}

export const BadgeStatus = styled("div", {
  shouldForwardProp: (prop) => prop !== "isActive",
})<BadgeStatusProps>(({ isActive }) => ({
  backgroundColor: isActive ? "#DCFBEA" : "#FEF3F2",
  color: isActive ? "#249F5D" : "#D92D20",
  borderRadius: "20px",
  padding: "6px 10px",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: "10px",
  lineHeight: "20px",
  display: "inline-block",
}));

export const ButtonChangeStatus = styled(Button)(() => ({
  whiteSpace: "nowrap",
  "& span": {
    display: "flex",
    gap: "10px",
    "& div": {
      display: "flex",
      alignItems: "center",
    },
  },
}));
